import util from '../util'

let controller = 'ContaCartao'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
  SituacaoCartao: function (codigoConta) {
    return util.Axios.Get(controller + '/Situacao', codigoConta)
  },
  BloqueioEDesbloqueio: function (codigoConta) {
    return util.Axios.Put(controller + '/BloqueioEDesbloqueio', codigoConta)
  },
  ObterSolicitacoesRealizadas: function (codigoParceiro) {
    return util.Axios.Get(controller + `/historico/${codigoParceiro}`)
  },
  ObterAutorizacaoTransacionalCartao: function (dto) {
    return util.Axios.GetAll(`${controller}/autorizacaoTransacionalCartao`, dto)
  }
})
